(() => {
  // ------------------------------------------------------------------
  // Données Shopify (sections/omi-accueil.liquid)
  // ------------------------------------------------------------------
  const DONNEES = JSON.parse(document.getElementById("omi-donnees").textContent);
  const R = DONNEES.reglages;
  const JOURS = ["Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi","Dimanche"]; // données (métaobjets) : toujours en français
  // Langue de la page (Shopify) : textes traduits dans assets/omi-textes.js, clé = texte français.
  // Les valeurs envoyées à la commande (sauces, retraits, créneau…) restent en français pour la cuisine.
  const LANGUE = (document.documentElement.lang || "fr").slice(0, 2);
  const TEXTES = (window.OMI_TEXTES || {})[LANGUE] || {};
  const t = (fr, v = {}) => (TEXTES[fr] || fr).replace(/\{(\w+)\}/g, (_, k) => v[k] ?? "");
  const LOCALE = { fr: "fr-FR", en: "en-GB", de: "de-DE", es: "es-ES", ar: "ar-u-nu-latn" }[LANGUE] || "fr-FR";
  const minus = x => ["fr", "es"].includes(LANGUE) ? x.toLowerCase() : x; // « lundi midi » ; « Monday lunch »
  const jourAff = dow => t(JOURS[dow - 1]);
  const per = s => t(s.periode.toLowerCase()); // midi / soir
  const LIEUX = DONNEES.emplacements;
  const PLANNING = { 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [] }; // 1 = lundi … 7 = dimanche
  for (const s of DONNEES.services) {
    const j = JOURS.indexOf(s.jour) + 1;
    if (s.actif && j && LIEUX[s.lieu] && s.debut && s.fin) PLANNING[j].push(s);
  }
  // Exceptions datées : remplacent le planning habituel ce jour-là, puis disparaissent.
  const EXCEPTIONS = DONNEES.exceptions.filter(e => e.date && (e.ferme || (LIEUX[e.lieu] && e.debut && e.fin)));
  // Emplacement « toujours sans commande en ligne » (ex. Ferme d'Idéfix : carte spéciale sur place) — sauf précommande
  for (const s of [...Object.values(PLANNING).flat(), ...EXCEPTIONS])
    if (LIEUX[s.lieu] && LIEUX[s.lieu].sansCommande && !s.precommandeFin) { s.sansCommande = true; s.surPlace = true; }
  // Raison d'une fermeture datée (ex. « En événement privé »), affichée à côté de « Fermé »
  const raisonDate = d => (EXCEPTIONS.find(e => e.ferme && e.raison && e.date === iso(d)) || {}).raison || "";
  const fermeTxt = d => raisonDate(d) ? `${t("Fermé")} · ${esc(raisonDate(d))}` : t("Fermé");
  const liste = v => Array.isArray(v) ? v : [];
  const CLE_PICTO = { "Halal": "halal", "Végé": "vege", "Spicy": "spicy", "Coup de cœur": "coeur" };
  const PRODUITS = DONNEES.produits.filter(Boolean).map(p => {
    const sauces = liste(p.sauces), ko = liste(p.saucesIndispo);
    return { ...p, carte: p.carte || "", tags: liste(p.tags).map(t => CLE_PICTO[t]).filter(Boolean), badge: p.badge || "",
      // Produit à plusieurs options hors menus classiques (ex. Menu Halloween : Burger × Frites) : choix dans la fiche
      variantes: !p.menu && (p.optionNames || []).length > 1 && (p.variants || []).length > 1,
      options: liste(p.retraits).length ? { type: "retrait", titre: t("Retirer des ingrédients"), choix: liste(p.retraits) }
        : sauces.length ? { type: "sauce", titre: t("Ta sauce (1 incluse)"), choix: sauces.map(c => ko.includes(c) ? { label: c, indispo: true } : c) }
        : null };
  });
  // Fried Chick : Sweet Chick et Spice Chick = une seule carte sur le site ; « HOT 🌶️ » coché = Spice Chick
  // (deux produits Shopify, pour que la cuisine voie tout de suite lequel préparer).
  const POULET = { doux: "sweet-chick", hot: "spice-chick", nom: "Fried Chick" };
  // Grilled Cheese (version végé) : 3 recettes = 3 produits Shopify, une seule carte ; la recette est à choisir (obligatoire).
  const GRILLED = { ids: ["grilled-cheese-og", "grilled-cheese-oklahoma", "grilled-cheese-truffle"], nom: "Grilled Cheese" };
  const estGrilled = id => GRILLED.ids.includes(id);
  const nomAff = p => p.id === POULET.doux ? POULET.nom : estGrilled(p.id) ? GRILLED.nom : p.nom;
  // Petite feuille verte après le nom des produits végé (cartes et liste de commande)
  const feuille = p => p.tags.includes("vege") ? `<svg class="feuille-vege" viewBox="0 0 16 16" aria-label="${t("Végé")}"><path d="M2.5 13.5C2.5 7 7 2.5 13.5 2.5c0 6.5-4.5 11-11 11z" fill="currentColor"/><path d="M3.5 12.5l6-6" stroke="#fff" stroke-width="1.3" stroke-linecap="round"/></svg>` : "";
  const recette = p => p.nom.replace(GRILLED.nom, "").trim();
  // Choix de la recette : [id, supplément] ; aucune cochée tant que le client n'a pas choisi
  const choixRecette = (nom, liste, val) => `<fieldset class="options"><legend>${t("Ta recette")}</legend><div class="choix">${liste.map(([id, sup]) => {
    const q = produit(id), ok = !indispo(q);
    return `<label><input type="radio" name="${nom}" value="${id}" ${val === id ? "checked" : ""} ${ok ? "" : "disabled"}>${esc(recette(q))}${sup ? ` +${sup} €` : ""}${ok ? "" : ` · ${minus(indispo(q))}`}</label>`;
  }).join("")}</div></fieldset>`;
  const caseHot = (nom, coche, ok) => `<fieldset class="options"><legend>${t("Tu le veux piquant ?")}</legend><div class="choix"><label><input type="checkbox" name="${nom}" ${coche ? "checked" : ""} ${ok ? "" : "disabled"}>HOT 🌶️</label></div></fieldset>`;
  // Menus = bundles Shopify (Burger × Frites × Boisson) : chaque composant garde son taux de TVA.
  // La version bière est un bundle à part (« menuBiere ») : le site y bascule quand on choisit la bière.
  // Shopify retire des bundles les options à valeur unique (ex. « Bière », « OG Single ») :
  // on reconstitue toujours le trio [Burger, Frites, Boisson] de chaque variante.
  function completer(p, defauts) {
    for (const v of p?.variants || []) {
      const o = Object.fromEntries((p.optionNames || []).map((n, i) => [n, v.options[i]]));
      v.options = ["Burger", "Frites", "Boisson"].map(n => o[n] ?? defauts[n]);
    }
  }
  for (const p of PRODUITS.filter(p => p.menu)) completer(p, { Burger: p.menuBurger, Frites: "Classic Fries" });
  completer(DONNEES.menuBiere, { Boisson: "Bière" });
  const PRODUIT_MENU = PRODUITS.find(p => p.menu && !p.menuBurger); // Menu Original (à composer)
  const VARIANTES_MENU = PRODUIT_MENU ? [...PRODUIT_MENU.variants, ...(DONNEES.menuBiere?.variants || [])] : [];
  const parNom = nom => PRODUITS.find(p => p.nom === nom && !p.carte); // menus classiques : carte habituelle
  const choixDe = (V, i) => [...new Set(V.map(v => v.options[i]))].filter(parNom);
  const MENU = { burgers: [], frites: [], boissons: [] };
  if (PRODUIT_MENU) {
    // Prix de base = OG Smash + Classic Fries + soda (le menu Grilled Cheese, moins cher, s'affiche en « −1 € »)
    const V0 = VARIANTES_MENU.filter(v => !v.options[0].startsWith(GRILLED.nom)), base = Math.min(...V0.map(v => v.prix));
    const sup = (i, val) => Math.min(...(i ? V0 : VARIANTES_MENU).filter(v => v.options[i] === val).map(v => v.prix)) - base;
    for (const [i, cle] of [[0, "burgers"], [1, "frites"], [2, "boissons"]])
      MENU[cle] = choixDe(VARIANTES_MENU, i).map(val => [parNom(val).id, Math.round(sup(i, val) * 100) / 100]);
    PRODUIT_MENU.prix = base;
  }
  const FILTRES = [["tout", "Tout"], ["menus", "Menus"], ["burgers", "Burgers"], ["accomp", "Accompagnements"], ["boissons", "Boissons"], ["desserts", "Desserts"], ["enfants", "Pour les enfants"]].map(([id, nom]) => [id, t(nom)]);
  let filtre = "tout";
  // Carte affichée : habituelle (""), ou carte spéciale de la précommande en cours (ex. « halloween », produits halloween-*)
  const carteActive = () => (location.hash.startsWith("#precommande") && preco()?.carte) || "";
  const carte = () => PRODUITS.filter(p => p.carte === carteActive() && p.id !== POULET.hot && !GRILLED.ids.slice(1).includes(p.id));
  const filtres = () => carte().filter(p => filtre === "tout" || p.cat === filtre);
  const PICTOS = {
    halal: { label: t("Halal"), svg: `<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10.5 2.5a6 6 0 1 0 3 9.8A5 5 0 0 1 10.5 2.5z" fill="currentColor"/></svg>` },
    vege:  { label: t("Végé"),  svg: `<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 13C3 7 7 3 13 3c0 6-4 10-10 10zM3 13l6-6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>` },
    coeur: { label: t("Coup de cœur"), svg: `<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 14s-5.6-3.4-5.6-7.3A3.1 3.1 0 0 1 8 4.8a3.1 3.1 0 0 1 5.6 1.9C13.6 10.6 8 14 8 14z" fill="currentColor"/></svg>` },
    spicy: { label: t("Spicy"), svg: `<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M11 4c-1 5-4 9-8 9 3-2 4-5 4.5-8.5C8 3.4 10 3 11 4zM11 4c0-1 .5-2 1.5-2.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>` },
  };
  let stockBurgers = Infinity;   // quota en ligne : branché avec le compteur de créneaux
  let MAX_PAR_CRENEAU = R.maxParCreneau; // un évènement peut en autoriser plus (champ « Burgers par créneau »)
  const OUVERTURE_AVANT = R.ouvertureAvant;
  const DELAI_MINI = R.delaiMini;

  // ------------------------------------------------------------------
  // Heure de Paris, recalculée chaque minute
  // ------------------------------------------------------------------
  const iso = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  let vraiJour, vraiDow;
  const sim = { dow: 1, min: 0 };
  function horloge() {
    const parts = Object.fromEntries(new Intl.DateTimeFormat("fr-FR", {
      timeZone: "Europe/Paris", year: "numeric", month: "numeric", day: "numeric",
      hour: "numeric", minute: "numeric", hourCycle: "h23"
    }).formatToParts(new Date()).map(p => [p.type, p.value]));
    vraiJour = new Date(+parts.year, +parts.month - 1, +parts.day);
    vraiDow = ((vraiJour.getDay() + 6) % 7) + 1;
    sim.dow = vraiDow; sim.min = +parts.hour * 60 + +parts.minute;
    if (TEST) { // mode test : on se place au prochain jour demandé, à l'heure demandée
      vraiJour.setDate(vraiJour.getDate() + (TEST.dow - vraiDow + 7) % 7);
      vraiDow = sim.dow = TEST.dow; sim.min = TEST.min;
    }
    maintenant = `${iso(vraiJour)}T${String(Math.floor(sim.min / 60)).padStart(2, "0")}:${String(sim.min % 60).padStart(2, "0")}`;
  }
  let maintenant = "";
  // Mode test (réglage « Mode test » du thème) : ajoute ?test=jeudi-12h15 à l'adresse pour simuler un jour et une heure.
  const TEST = (() => {
    const m = R.modeTest && (new URLSearchParams(location.search).get("test") || "").toLowerCase().match(/^([a-zé]+)-(\d{1,2})h(\d{2})?$/);
    const dow = m ? JOURS.findIndex(j => j.toLowerCase() === m[1]) + 1 : 0;
    return dow ? { dow, min: +m[2] * 60 + +(m[3] || 0), texte: `${JOURS[dow - 1].toLowerCase()} ${m[2]}h${m[3] || "00"}` } : null;
  })();
  horloge();
  if (TEST) document.body.insertAdjacentHTML("afterbegin",
    `<div class="bandeau-test">Mode test : ${TEST.texte}. Les commandes passées ainsi sont marquées « test ».</div>`);
  // Lignes { id, opts (affichage), n, prix, variant (id Shopify), props (propriétés de ligne) }
  const panier = (() => { try { return JSON.parse(localStorage.getItem("omi-panier")) || []; } catch { return []; } })();
  const sauver = () => { try { localStorage.setItem("omi-panier", JSON.stringify(panier)); } catch {} };
  const produit = id => PRODUITS.find(x => x.id === id);
  function ajouter(id, opts = [], prix, variant, props) {
    const p = produit(id);
    const l = panier.find(x => x.id === id && x.opts.join() === opts.join());
    if (l) l.n++;
    else panier.push({ id, opts, n: 1, prix: prix ?? p.prix, variant: variant ?? p.variants[0].id, props: props ?? (opts.length ? { "Choix": opts.join(", ") } : {}) });
    sauver();
  }
  function retirerUn(i) { panier[i].n--; if (!panier[i].n) panier.splice(i, 1); sauver(); }
  const qteProduit = id => panier.filter(l => l.id === id).reduce((a, l) => a + l.n, 0);
  const nbArticles = () => panier.reduce((a, l) => a + l.n, 0);
  // Pas de licence pour vendre de l'alcool seul : une commande ne peut pas contenir que de la bière.
  const alcoolSeul = () => panier.length > 0 && panier.every(l => produit(l.id)?.alcool);
  // Regroupe par familles (Burgers, Accompagnements, Sodas…) avec un intertitre.
  const parGroupe = (liste, carte, classe) => [...new Set(liste.map(p => p.groupe))].map(g =>
    `<h3 class="groupe t">${esc(g)}</h3><div class="${classe}">${liste.filter(p => p.groupe === g).map(carte).join("")}</div>`).join("");
  let creneauChoisi = null, heureRetrait = null, compris = false, repartition = "";

  const $ = id => document.getElementById(id);
  const min = s => { const [h, m] = s.split(":").map(Number); return h * 60 + m; };
  const hh = m => `${Math.floor(m / 60)}h${String(m % 60).padStart(2, "0")}`; // format des données (créneaux, compteur)
  const hA = m => LANGUE === "fr" ? hh(m) : `${Math.floor(m / 60)}:${String(m % 60).padStart(2, "0")}`; // affichage
  const plage = s => LANGUE === "ar" ? `\u2066${hA(min(s.debut))} – ${hA(min(s.fin))}\u2069` // arabe : plage gardée de gauche à droite
    : `${hA(min(s.debut))} – ${hA(min(s.fin))}`;
  const dateDu = dow => { const d = new Date(vraiJour); d.setDate(d.getDate() + (dow - vraiDow)); return d; };
  const dateCourte = d => d.toLocaleDateString(LOCALE, { day: "numeric", month: "short" });
  const jourDate = d => `${jourAff(((d.getDay() + 6) % 7) + 1)} ${dateCourte(d)}`;
  const maps = l => l.maps || "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(l.nom + ", " + l.adresse);
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const adr = l => LANGUE === "ar" ? `\u2066${esc(l.adresse)}\u2069` : esc(l.adresse); // arabe : adresse française gardée dans l'ordre
  const euros = n => n.toFixed(2).replace(".", ",") + " €";
  const visuel = p => p.photo ? `<img class="photo" src="${p.photo}" alt="${esc(p.nom)}">`
    : p.detoure ? `<img class="photo-detouree" src="${p.detoure}" alt="${esc(p.nom)}">`
    : p.icone ? `<svg class="sticker sticker--icone" aria-hidden="true"><use href="#ic-${p.icone}"/></svg>`
    : `<span class="sans-photo">${t("Photo à venir")}</span>`;
  const badge = () => ""; // étiquettes retirées : la photo parle d'elle-même
  // Sticker du personnage posé en coin sur la photo (cartes + fiche)
  const perso = p => p.photo && p.perso ? `<img class="perso" src="${p.perso}" alt="" aria-hidden="true">` : "";
  const indispo = p => p.soon ? t("Bientôt") : p.indispo ? t("Indispo aujourd'hui") : "";
  // Allergènes (règlement INCO) : champs omi.allergenes / omi.traces de chaque produit
  const allergenes = p => {
    if (p.menu || p.variantes) return `<p class="detail__allergenes">${t("Allergènes : voir la fiche de chaque produit du menu.")}</p>`;
    const a = liste(p.allergenes), tr = liste(p.traces);
    if (!p.allergenesOk) return `<p class="detail__allergenes">${t("Allergènes : demande-nous au camion ou par téléphone avant de commander.")}</p>`;
    return `<p class="detail__allergenes"><strong>${t("Allergènes")} :</strong> ${a.length ? a.map(x => esc(t(x))).join(", ") : t("aucun")}${tr.length ? `. ${t("Peut contenir des traces de")} ${tr.map(x => esc(t(x)).toLowerCase()).join(", ")}` : ""}.</p>`;
  };
  // Allergènes de chaque sauce au choix (champ omi.allergenes_sauces des frites) ; sauce non renseignée = « demande-nous »
  const allergenesSauces = f => {
    const tab = f?.saucesAllergenes; if (!tab || !f.options || f.options.type !== "sauce") return "";
    return `<p class="detail__allergenes"><strong>${t("Allergènes des sauces")} :</strong> ${f.options.choix.map(c => {
      const nom = c.label || c, l = tab[nom];
      return `${esc(t(nom))} : ${l ? (l.length ? l.map(x => esc(t(x)).toLowerCase()).join(", ") : t("aucun")) : t("demande-nous")}`;
    }).join(" · ")}.</p>`;
  };
  const telHtml = `<a href="${R.telLien}">${esc(R.telephone)}</a>`;

  function etatService(s, m) {
    if (m >= min(s.fin)) return "fini";
    if (m >= min(s.debut)) return "ouvert";
    return "avenir";
  }
  // Services d'une date : planning du jour de la semaine + exceptions (fermeture ou service ajouté/modifié).
  function servicesDate(d) {
    let liste = [...PLANNING[((d.getDay() + 6) % 7) + 1]];
    for (const ex of EXCEPTIONS.filter(e => e.date === iso(d))) {
      liste = liste.filter(x => ex.periode !== "Journée" && x.periode !== ex.periode);
      if (!ex.ferme) liste.push(ex);
    }
    return liste.sort((a, b) => min(a.debut) - min(b.debut));
  }
  const servicesDu = dow => servicesDate(dateDu(dow));
  function prochainService(dow, m, commandable = false) {
    for (let i = 0; i < 45; i++) { // jusqu'à 6 semaines : couvre une fermeture longue (congés)
      const d = dateDu(dow); d.setDate(d.getDate() + i);
      const j = ((d.getDay() + 6) % 7) + 1;
      for (const s of servicesDate(d)) if ((i > 0 || min(s.fin) > m) && !(commandable && (s.sansCommande || s.precommandeFin))) return { ecart: i, dow: j, s, d };
    }
    return null;
  }
  const quand = p => p.ecart === 0 ? t("aujourd'hui {p}", { p: per(p.s) })
    : p.ecart === 1 ? t("demain {p}", { p: per(p.s) })
    : p.ecart < 7 ? t("{j} {p}", { j: minus(jourAff(p.dow)), p: per(p.s) })
    : t("{j} {d} {p}", { j: minus(jourAff(p.dow)), d: dateCourte(p.d), p: per(p.s) });

  // ------------------------------------------------------------------
  // Où sommes-nous
  // ------------------------------------------------------------------
  function rendreOu() {
    $("ou-titre").textContent = jourDate(dateDu(sim.dow));
    rendrePrecos();
    const services = servicesDu(sim.dow);
    const el = $("ou-contenu");
    if (!services.length) {
      const p = prochainService(sim.dow, 24 * 60);
      const r = raisonDate(dateDu(sim.dow)), raison = r ? `<p class="ferme__raison"><strong>${esc(r)}</strong></p>` : "";
      if (!p) { el.innerHTML = `<div class="ferme"><p class="ferme__titre t">${t("Fermé aujourd'hui")}</p>${raison}<p>${t("Le planning arrive très vite.")}</p></div>`; return; }
      const l = LIEUX[p.s.lieu];
      el.innerHTML = `<div class="ferme">
        <p class="ferme__titre t">${t("Fermé aujourd'hui")}</p>${raison}
        <p>${t("On se retrouve <strong>{q}</strong> à <strong>{l}</strong>, {h}.", { q: quand(p), l: esc(l.nom), h: plage(p.s) })}</p>
        <p><a href="${maps(l)}" target="_blank" rel="noopener">${t("Voir l'itinéraire →")}</a></p></div>`;
      return;
    }
    el.innerHTML = `<div class="services">${services.map(s => {
      const l = LIEUX[s.lieu], e = etatService(s, sim.min);
      const pastille = e === "ouvert" ? `<span class="pastille pastille--on">${t("Ouvert")}</span>`
        : e === "fini" ? `<span class="pastille">${t("Terminé")}</span>`
        : `<span class="pastille">${t("Dès {h}", { h: hA(min(s.debut)) })}</span>`;
      return `<article class="service ${e === "fini" ? "service--fini" : ""}">
        <div class="service__haut"><span class="eyebrow">${t(s.periode)}</span>${pastille}</div>
        <h3 class="service__lieu t">${esc(l.nom)}</h3>
        <p class="service__adresse">${adr(l)}</p>${l.instructions ? `<p class="service__instructions">${esc(l.instructions)}</p>` : ""}
        ${s.sansCommande ? `<p class="service__instructions">${s.surPlace ? t("Pas de commande en ligne, on te sert directement au camion.") : t("Évènement : pas de commande en ligne, on te sert sur place.")}</p>` : ""}
        ${s.precommandeFin && !precoOuverte(s) ? `<p class="service__instructions">${t("Précommandes terminées : on se retrouve au camion !")}</p>` : ""}
        <div class="service__bas"><span class="heures">${plage(s)}</span>
          ${e === "fini" ? "" : `<a class="btn btn--petit" href="${maps(l)}" target="_blank" rel="noopener">${t("Itinéraire")}</a>`}</div>
      </article>`;
    }).join("")}</div>`;
    if (services.every(s => etatService(s, sim.min) === "fini")) {
      const p = prochainService(sim.dow, 24 * 60);
      el.insertAdjacentHTML("beforeend", `<p class="suite">${t("C'est fini pour aujourd'hui. Prochain service <strong>{q}</strong> à <strong>{l}</strong>.", { q: quand(p), l: esc(LIEUX[p.s.lieu].nom) })}</p>`);
    }
  }

  // Grand écran : les jours suivants de la semaine en cours, jours fermés compris. La semaine prochaine
  // n'est montrée que si son planning est publié (au moins une exception datée cette semaine-là, dictée le dimanche) ;
  // sinon : « publié dimanche ».
  function semainePubliee(lundi) {
    const fin = new Date(lundi); fin.setDate(fin.getDate() + 6);
    return EXCEPTIONS.some(e => !e.precommandeFin && e.date >= iso(lundi) && e.date <= iso(fin));
  }
  function rendreAvenir() {
    let html = "";
    for (let i = 1; i <= 6; i++) {
      const d = new Date(vraiJour); d.setDate(d.getDate() + i);
      const dow = ((d.getDay() + 6) % 7) + 1, services = servicesDate(d);
      if (dow === 1) {
        html += `<div class="avenir__semaine eyebrow">${t("Semaine prochaine")}</div>`;
        if (!semainePubliee(d)) {
          html += `<p class="avenir__bientot">${vraiDow === 7 ? t("Le planning de la semaine prochaine est publié aujourd'hui, ici et en story Instagram.") : t("Le planning de la semaine prochaine est publié dimanche, ici et en story Instagram.")}</p>`;
          break;
        }
      }
      html += `<div class="jour ${services.length ? "" : "jour--vide"}">
        <div class="jour__nom t">${i === 1 ? t("Demain") : jourAff(dow)}<span class="jour__date">${i === 1 ? jourAff(dow) + " " : ""}${dateCourte(d)}</span></div>
        ${services.length ? `<div class="jour__services">${services.map(s => {
          const l = LIEUX[s.lieu];
          return `<div><div class="js__periode">${t(s.periode)} · ${plage(s)}</div><div class="js__lieu">${esc(l.nom)}</div>
            <div class="js__ligne">${adr(l)} · <a href="${maps(l)}" target="_blank" rel="noopener">Maps</a></div></div>`;
        }).join("")}</div>` : `<div class="jour__ferme">${fermeTxt(d)}</div>`}
      </div>`;
    }
    $("ou-avenir").innerHTML = `<div class="eyebrow avenir__titre">${t("À venir")}</div>${html}`;
  }

  function rendreSemaine() {
    // Le dimanche, dès que le planning de la semaine suivante est publié, on montre la semaine qui arrive
    const decalage = vraiDow === 7 && semainePubliee(dateDu(8)) ? 7 : 0;
    $("semaine").innerHTML = JOURS.map((nom, i) => {
      const dow = i + 1, d = dateDu(dow + decalage), services = servicesDate(d), auj = !decalage && dow === sim.dow;
      return `<div class="jour ${auj ? "jour--auj" : ""}">
        <div class="jour__nom t">${jourAff(dow)}<span class="jour__date">${dateCourte(d)}</span>${auj ? `<span class="tag">${t("AUJOURD'HUI")}</span>` : ""}</div>
        ${services.length ? `<div class="jour__services">${services.map(s => {
          const l = LIEUX[s.lieu];
          return `<div><div class="js__periode">${t(s.periode)} · ${plage(s)}</div><div class="js__lieu">${esc(l.nom)}</div>
            <div class="js__ligne">${adr(l)} · <a href="${maps(l)}" target="_blank" rel="noopener">Maps</a></div></div>`;
        }).join("")}</div>` : `<div class="jour__ferme">${fermeTxt(d)}</div>`}
      </div>`;
    }).join("");
  }

  // ------------------------------------------------------------------
  // Menu vitrine + fiche produit
  // ------------------------------------------------------------------
  function rendreVitrine() {
    $("vitrine").innerHTML = parGroupe(filtres(), p => {
      const off = indispo(p);
      return `<button type="button" class="carte ${off ? "carte--off" : ""}" data-detail="${p.id}">
        ${perso(p)}<span class="carte__visuel">${visuel(p)}${badge(p)}${off ? `<span class="bandeau">${off}</span>` : ""}</span>
        <span class="carte__nom t">${esc(nomAff(p))}${feuille(p)}</span></button>`;
    }, "vitrine");
  }

  // Fiche du menu : choix burger / retraits / frites / sauce / boisson, prix recalculé à chaque choix.
  let choixMenu = null;
  const dispo = id => !indispo(produit(id));
  function prixMenu() {
    return varianteMenu()?.prix ?? choixMenu.p.prix;
  }
  function optionsMenu() {
    const radios = (nom, titre, liste, val) => `<fieldset class="options"><legend>${titre}</legend><div class="choix">${liste.map(([id, sup]) => {
      const q = produit(id), ok = dispo(id);
      return `<label><input type="radio" name="${nom}" value="${id}" ${val === id ? "checked" : ""} ${ok ? "" : "disabled"}>${esc(nomAff(q))}${sup ? ` ${sup > 0 ? "+" : "−"}${Math.abs(sup)} €` : ""}${ok ? "" : ` · ${minus(indispo(q))}`}</label>`;
    }).join("")}</div></fieldset>`;
    const fixe = choixMenu.fixe, f = produit(choixMenu.frites);
    const bm = produit(burgerMenu());
    const listeRetraits = fixe ? liste(choixMenu.p.retraits) : (bm.options?.type === "retrait" ? bm.options.choix : []);
    const retraits = listeRetraits.length ? `<fieldset class="options"><legend>${t("Retirer des ingrédients")}</legend><div class="choix">${listeRetraits.map(c =>
      `<label><input type="checkbox" name="retrait" value="${esc(c)}" ${choixMenu.retraits.includes(c) ? "checked" : ""}>${esc(t(c))}</label>`).join("")}</div></fieldset>` : "";
    const sauce = f.options ? allergenesSauces(f) + `<fieldset class="options"><legend>${f.options.titre}</legend><div class="choix">${["Sans sauce", ...f.options.choix].map(c => {
      const label = c.label || c, ko = !!c.indispo;
      return `<label><input type="radio" name="sauce" value="${esc(label)}" ${choixMenu.sauce === label ? "checked" : ""} ${ko ? "disabled" : ""}>${esc(t(label))}${ko ? ` · ${t("indispo")}` : ""}</label>`;
    }).join("")}</div></fieldset>` : "";
    const impose = (titre, nom) => `<fieldset class="options"><legend>${titre}</legend><div class="choix"><label><input type="radio" checked disabled>${esc(nom)}</label></div></fieldset>`;
    if (fixe) return impose(t("Ton burger"), choixMenu.p.menuBurger) + retraits + impose(t("Tes frites"), f.nom) + sauce
      + radios("m-boisson", t("Ta boisson"), choixDe(choixMenu.p.variants, 2).map(n => [parNom(n).id, 0]), choixMenu.boisson);
    const supG = id => (MENU.burgers.find(([x]) => x === id) || [, 0])[1] - (MENU.burgers.find(([x]) => x === GRILLED.ids[0]) || [, 0])[1];
    return radios("m-burger", t("Ton burger"), MENU.burgers.filter(([id]) => id !== POULET.hot && !GRILLED.ids.slice(1).includes(id)), choixMenu.burger)
      + (choixMenu.burger === POULET.doux ? caseHot("m-hot", choixMenu.hot, dispo(POULET.hot)) : "")
      + (estGrilled(choixMenu.burger) ? choixRecette("m-recette", GRILLED.ids.filter(id => MENU.burgers.some(([x]) => x === id)).map(id => [id, supG(id)]), choixMenu.recette) : "") + retraits
      + radios("m-frites", t("Tes frites"), MENU.frites, choixMenu.frites) + sauce
      + radios("m-boisson", t("Ta boisson"), MENU.boissons, choixMenu.boisson);
  }
  function rendreChoixMenu() {
    $("menu-choix").innerHTML = optionsMenu();
    const b = $("detail-corps").querySelector("[data-ajouter]");
    if (b) { const manque = !choixMenu.fixe && estGrilled(choixMenu.burger) && !choixMenu.recette;
      b.disabled = manque; b.textContent = manque ? t("Choisis ta recette") : `${t("Ajouter")} · ${euros(prixMenu())}`; }
    $("menu-prix").textContent = euros(prixMenu());
  }
  // Fiche du Grilled Cheese : recette (obligatoire) puis retraits de cette recette ; prix de la recette choisie.
  let choixGrilled = null;
  function rendreGrilled() {
    const base = Math.min(...GRILLED.ids.map(id => produit(id)?.prix ?? Infinity));
    const q = choixGrilled.id && produit(choixGrilled.id), r = q?.options?.type === "retrait" ? q.options.choix : [];
    $("grilled-choix").innerHTML = choixRecette("recette", GRILLED.ids.filter(produit).map(id => [id, Math.round((produit(id).prix - base) * 100) / 100]), choixGrilled.id)
      + (r.length ? `<fieldset class="options"><legend>${t("Retirer des ingrédients")}</legend><div class="choix">${r.map(c =>
        `<label><input type="checkbox" name="opt" value="${esc(c)}">${esc(t(c))}</label>`).join("")}</div></fieldset>` : "");
    const b = $("detail-corps").querySelector("[data-ajouter]");
    if (b) { b.disabled = !q; b.textContent = q ? `${t("Ajouter")} · ${euros(q.prix)}` : t("Choisis ta recette"); }
    $("menu-prix").textContent = euros(q ? q.prix : base);
  }
  $("detail-corps").addEventListener("change", e => { if (choixGrilled && e.target.name === "recette") { choixGrilled.id = e.target.value; rendreGrilled(); } });
  // Fiche d'un produit à variantes (Menu Halloween) : une rangée de choix par option, supplément affiché, prix recalculé.
  let choixVar = null;
  const varianteChoisie = () => choixVar.p.variants.find(v => v.options.join("|") === choixVar.val.join("|"));
  const LIBELLES = { Burger: "Ton burger", Frites: "Tes frites" };
  // Ce qui est inclus d'office dans un menu à variantes (affiché coché, sans choix possible)
  const INCLUS = { "halloween-menu": [["Ton dessert", "Cookie Maison"]] };
  function rendreChoixVar() {
    const p = choixVar.p, base = Math.min(...p.variants.map(v => v.prix));
    const sup = (i, val) => Math.round((Math.min(...p.variants.filter(v => v.options[i] === val).map(v => v.prix)) - base) * 100) / 100;
    const burger = PRODUITS.find(x => x.carte === p.carte && x.nom === choixVar.val[p.optionNames.indexOf("Burger")]);
    const retraits = liste(burger?.retraits);
    $("menu-choix").innerHTML = p.optionNames.map((n, i) => `<fieldset class="options"><legend>${t(LIBELLES[n] || n)}</legend><div class="choix">${
      [...new Set(p.variants.map(v => v.options[i]))].map(val => `<label><input type="radio" name="v-${i}" value="${esc(val)}" ${choixVar.val[i] === val ? "checked" : ""}>${esc(val)}${sup(i, val) ? ` +${sup(i, val)} €` : ""}</label>`).join("")
    }</div></fieldset>${n === "Burger" && retraits.length ? `<fieldset class="options"><legend>${t("Retirer des ingrédients")}</legend><div class="choix">${retraits.map(c =>
      `<label><input type="checkbox" name="v-retrait" value="${esc(c)}" ${choixVar.retraits.includes(c) ? "checked" : ""}>${esc(t(c))}</label>`).join("")}</div></fieldset>` : ""}`).join("")
      + (INCLUS[p.id] || []).map(([titre, nom]) => `<fieldset class="options"><legend>${t(titre)}</legend><div class="choix"><label><input type="radio" checked disabled>${esc(t(nom))}</label></div></fieldset>`).join("");
    const prix = varianteChoisie()?.prix ?? p.prix;
    const b = $("detail-corps").querySelector("[data-ajouter]");
    if (b) b.textContent = `${t("Ajouter")} · ${euros(prix)}`;
    $("menu-prix").textContent = euros(prix);
  }
  $("detail-corps").addEventListener("change", e => {
    if (!choixVar || !e.target.name?.startsWith("v-")) return;
    if (e.target.name === "v-retrait") choixVar.retraits = [...$("menu-choix").querySelectorAll("input[name=v-retrait]:checked")].map(x => x.value);
    else { choixVar.val[+e.target.name.slice(2)] = e.target.value; if (e.target.name === `v-${choixVar.p.optionNames.indexOf("Burger")}`) choixVar.retraits = []; }
    rendreChoixVar();
  });
  $("detail-corps").addEventListener("change", e => {
    if (!choixMenu || !e.target.name) return;
    const v = e.target.value;
    if (e.target.name === "m-burger") { choixMenu.burger = v; choixMenu.retraits = []; choixMenu.hot = false; choixMenu.recette = null; }
    if (e.target.name === "m-recette") { choixMenu.recette = v; choixMenu.retraits = []; }
    if (e.target.name === "m-hot") choixMenu.hot = e.target.checked;
    if (e.target.name === "retrait") choixMenu.retraits = [...$("menu-choix").querySelectorAll("input[name=retrait]:checked")].map(x => x.value);
    if (e.target.name === "m-frites") choixMenu.frites = v;
    if (e.target.name === "sauce") choixMenu.sauce = v;
    if (e.target.name === "m-boisson") choixMenu.boisson = v;
    rendreChoixMenu();
  });
  // Variante Shopify du menu correspondant aux choix (Burger × Frites × niveau de boisson) + propriétés de ligne.
  const burgerMenu = () => choixMenu.burger === POULET.doux && choixMenu.hot ? POULET.hot : estGrilled(choixMenu.burger) ? choixMenu.recette || choixMenu.burger : choixMenu.burger;
  function varianteMenu() {
    const b = choixMenu.fixe ? choixMenu.p.menuBurger : produit(burgerMenu()).nom;
    const cible = [b, produit(choixMenu.frites).nom, produit(choixMenu.boisson).nom].join("|");
    return (choixMenu.fixe ? choixMenu.p.variants : VARIANTES_MENU).find(v => v.options.join("|") === cible);
  }
  const propsMenu = () => {
    // Burger, frites et boisson sont déjà dans la variante du bundle : on ne garde que les précisions.
    const f = produit(choixMenu.frites), props = {};
    if (choixMenu.retraits.length) props["Retraits"] = choixMenu.retraits.join(", ");
    if (f.options) props["Sauce"] = choixMenu.sauce;
    return props;
  };
  const optsMenu = () => [choixMenu.fixe ? choixMenu.p.menuBurger : produit(burgerMenu()).nom, ...choixMenu.retraits.map(c => t(c)),
    produit(choixMenu.frites).nom + (produit(choixMenu.frites).options ? ` · ${t(choixMenu.sauce)}` : ""), produit(choixMenu.boisson).nom];

  function ouvrirDetail(id) {
    const p = PRODUITS.find(x => x.id === id);
    choixMenu = p.menu ? { p, fixe: !!p.menuBurger, burger: MENU.burgers.map(([x]) => x).find(dispo), retraits: [],
      frites: (MENU.frites.find(([, sup]) => !sup) || MENU.frites[0])?.[0], sauce: "Sans sauce",
      boisson: (MENU.boissons.find(([id, sup]) => !sup && dispo(id)) || MENU.boissons[0])?.[0] } : null;
    const s = serviceCommandable(), off = indispo(p);
    $("detail-titre").textContent = nomAff(p);
    let bouton = "", note = "";
    if (off) note = `<p class="detail__note"><strong>${off}.</strong> ${p.soon ? t("Il arrive très vite au camion.") : t("Il revient très vite.")}</p>`;
    else if (!s) note = `<p class="detail__note">${messageCommande().txt}</p>`;
    else bouton = `<button type="button" class="btn btn--plein" data-ajouter="${p.id}">${t("Ajouter")} · ${euros(p.prix)}</button>`;
    choixVar = p.variantes ? { p, val: p.optionNames.map((_, i) => p.variants.reduce((a, v) => v.prix < a.prix ? v : a).options[i]), retraits: [] } : null;
    choixGrilled = estGrilled(p.id) ? { id: null } : null;
    const o = p.menu || choixGrilled ? null : p.options; // les options d'un menu sont gérées par optionsMenu(), celles du Grilled Cheese par rendreGrilled()
    const options = o && !off && s ? `<fieldset class="options" id="options"><legend>${o.titre}</legend><div class="choix">${
      (o.type === "sauce" ? ["Sans sauce", ...o.choix] : o.choix).map((c, i) => {
        const label = c.label || c, ko = !!c.indispo;
        return `<label><input type="${o.type === "sauce" ? "radio" : "checkbox"}" name="opt" value="${esc(label)}" ${o.type === "sauce" && i === 0 ? "checked" : ""} ${ko ? "disabled" : ""}>${esc(t(label))}${ko ? ` · ${t("indispo")}` : ""}</label>`;
      }).join("")}</div></fieldset>` : "";
    const hot = p.id === POULET.doux && !off && s ? caseHot("hot", false, dispo(POULET.hot)) : "";
    $("detail-corps").innerHTML = `
      <div class="detail__haut">${perso(p)}<div class="detail__visuel">${visuel(p)}${badge(p)}</div></div>
      <div class="pictos">${p.tags.map(t => `<span class="picto picto--${t}">${PICTOS[t].svg}${PICTOS[t].label}</span>`).join("")}</div>
      <p class="detail__desc">${esc(p.desc)}</p>${allergenes(p)}${p.menu ? "" : allergenesSauces(p)}${p.alcool ? `<p class="detail__alcool">${t("Vente d'alcool interdite aux mineurs.")} ${t("L'abus d'alcool est dangereux pour la santé, à consommer avec modération.")}</p>` : ""}${options}${hot}
      ${(p.menu || p.variantes) && s ? `<div id="menu-choix"></div>` : ""}${choixGrilled && !off && s ? `<div id="grilled-choix"></div>` : ""}
      <div class="detail__bas"><span class="detail__prix" id="menu-prix">${euros(p.prix)}</span>${bouton}</div>${note}`;
    if (p.menu && s) rendreChoixMenu();
    if (p.variantes && s) rendreChoixVar();
    if (choixGrilled && !off && s) rendreGrilled();
    $("detail").showModal();
  }

  // ------------------------------------------------------------------
  // Commande : fenêtre, stock, créneaux
  // ------------------------------------------------------------------
  // Avant le service : premier créneau = début. Pendant : 30 min de délai.
  // Premier retrait : début du service + décalage (réglage « Premier retrait après le début du service ») ; pendant le service : +30 min.
  const premierCreneau = s => s.precommandeFin ? min(s.debut)
    : Math.max(min(s.debut) + (R.premierDecalage || 0), sim.min < min(s.debut) ? 0 : Math.ceil((sim.min + DELAI_MINI) / 15) * 15);
  function creneaux(s) {
    MAX_PAR_CRENEAU = s.maxParCreneau || R.maxParCreneau;
    const out = [];
    for (let t = min(s.debut); t < min(s.fin); t += 15) {
      out.push({ debut: t, pris: Math.min(MAX_PAR_CRENEAU, occupation[`${iso(jourCommande())} ${hh(t)}`] || 0) });
    }
    return out;
  }
  // Remplit le créneau choisi, puis déborde sur les créneaux suivants.
  function reservation(liste, idx, nb) {
    const res = []; let reste = nb;
    for (let i = idx; i < liste.length && reste > 0; i++) {
      const libre = MAX_PAR_CRENEAU - liste[i].pris;
      if (libre <= 0) return null;
      const n = Math.min(libre, reste);
      res.push({ debut: liste[i].debut, n });
      reste -= n;
    }
    return reste > 0 ? null : res;
  }
  // ------------------------------------------------------------------
  // Précommande (évènement daté, ex. Halloween) : exception du planning avec « Précommande jusqu'au ».
  // Ouverte dès sa création, jusqu'à la date limite et au plus tard la veille ; le jour J, commandes normales.
  // Page dédiée : #precommande (le panier et les créneaux portent alors sur la date de l'évènement).
  // ------------------------------------------------------------------
  const dateIso = x => { const [a, m, j] = x.split("-").map(Number); return new Date(a, m - 1, j); };
  const precosOuvertes = () => R.pause ? [] : EXCEPTIONS.filter(e => e.precommandeFin && !e.ferme && !e.sansCommande
    && e.date > iso(vraiJour) && maintenant < e.precommandeFin);
  // Encart affiché jusqu'à la fin du service de l'évènement : cliquable tant que la précommande est ouverte,
  // grisé ensuite (« on se retrouve au camion »), puis il disparaît tout seul après l'évènement.
  const precosAffichees = () => EXCEPTIONS.filter(e => e.precommandeFin && !e.ferme && !e.sansCommande
    && (e.date > iso(vraiJour) || (e.date === iso(vraiJour) && sim.min < min(e.fin))));
  const precoOuverte = e => !R.pause && e.date > iso(vraiJour) && maintenant < e.precommandeFin;
  const preco = () => location.hash.startsWith("#precommande") ? precosOuvertes().find(e => location.hash === "#precommande" || location.hash === `#precommande-${e.date}`) || null : null;
  const jourCommande = () => preco() ? dateIso(preco().date) : vraiJour;
  const finPreco = e => { const [d, h] = e.precommandeFin.split("T"); return t("{j} à {h}", { j: minus(jourDate(dateIso(d))), h: hA(min(h)) }); };
  function rendrePrecos() {
    const el = $("ou-preco"); if (!el) return;
    // Un même évènement sur plusieurs jours (ex. Halloween samedi + dimanche) = un seul encart, un bouton par jour
    const groupes = [];
    for (const e of precosAffichees().sort((a, b) => a.date.localeCompare(b.date))) {
      const g = groupes.find(g => g[0].nom === e.nom && g[0].lieu === e.lieu && g[0].carte === e.carte);
      if (g) g.push(e); else groupes.push([e]);
    }
    el.innerHTML = groupes.map(g => {
      const e = g[0], ouv = g.filter(precoOuverte), une = g.length === 1, ouverte = ouv.length > 0, tag = une && ouverte ? "a" : "div";
      const jours = g.map(x => jourDate(dateIso(x.date))).map((j, i) => i ? minus(j) : j);
      const quand = jours.length > 1 ? `${jours.slice(0, -1).join(", ")} ${t("et")} ${jours.at(-1)}` : jours[0];
      const texte = !ouverte
        ? t("{j}, {p} ({h}) à <strong>{l}</strong>. On se retrouve au camion : on sert d'abord les précommandes, puis tout le monde sur place !", { j: quand, p: per(e), h: plage(e), l: esc(LIEUX[e.lieu].nom) })
        : une ? t("{j}, {p} ({h}) à <strong>{l}</strong>. Commande à l'avance et choisis ton créneau, jusqu'au {f}.", { j: quand, p: per(e), h: plage(e), l: esc(LIEUX[e.lieu].nom), f: finPreco(e) })
        : t("{j}, {p} ({h}) à <strong>{l}</strong>. Commande à l'avance et choisis ton créneau.", { j: quand, p: per(e), h: plage(e), l: esc(LIEUX[e.lieu].nom) });
      const boutons = une
        ? (ouverte ? `<span class="btn btn--petit btn--plein">${t("Précommander")}</span>` : `<span class="btn btn--petit" aria-disabled="true">${t("Précommandes terminées")}</span>`)
        : `<span class="encart-preco__jours">${g.map((x, i) => precoOuverte(x)
            ? `<a class="btn btn--petit btn--plein" href="#precommande-${x.date}">${t("Précommander")} · ${minus(jours[i]).replace(/ \S+\.$/, "")}</a><small>${t("jusqu'au {f}", { f: finPreco(x) })}</small>`
            : `<span class="btn btn--petit" aria-disabled="true">${minus(jours[i]).replace(/ \S+\.$/, "")} · ${t("Précommandes terminées")}</span><small></small>`).join("")}</span>`;
      const garantie = ouverte ? ` ${t("La précommande te garantit ton burger, et il y aura aussi de quoi acheter sur place.")}` : "";
      return `<${tag} class="encart-evt encart-preco ${e.carte ? `encart-preco--${esc(e.carte)}` : ""} ${ouverte ? "" : "encart-preco--fini"}" ${tag === "a" ? `href="#precommande-${e.date}"` : ouverte ? "" : `aria-disabled="true"`}>${e.carte === "halloween" ? `<span class="fantome" aria-hidden="true">👻</span>` : ""}
      <span class="eyebrow">${ouverte ? t("Précommande ouverte") : t("Précommandes terminées")}</span>
      <span class="encart-evt__titre t">${esc(e.nom || LIEUX[e.lieu].nom)}</span>
      <span class="encart-evt__texte">${texte}${garantie}</span>${boutons}</${tag}>`;
    }).join("");
  }
  function serviceCommandable() {
    if (location.hash.startsWith("#precommande")) return preco();
    if (R.pause) return null; // interrupteur « Commandes en ligne en pause »
    for (const s of servicesDu(sim.dow)) {
      if (s.sansCommande || s.precommandeFin) continue; // évènement : sur place seulement (ou précommande close)
      if (R.stopDebut && sim.min >= min(s.debut)) continue; // réglage « Fermer les commandes au début du service »
      if (sim.min >= min(s.debut) - OUVERTURE_AVANT && creneaux(s).some(c => c.debut >= premierCreneau(s))) return s;
    }
    return null;
  }
  const burgersPanier = () => panier.reduce((a, l) => a + (produit(l.id).burger ? l.n : 0), 0);
  const totalPanier = () => panier.reduce((t, l) => t + l.prix * l.n, 0);

  function messageCommande() {
    if (R.pause) return { s: null, txt: `<strong>${t("Commandes en ligne en pause.")}</strong> ${esc(R.pauseMessage || "")} ${t("Passe au camion ou appelle-nous au {tel}.", { tel: telHtml })}` };
    if (location.hash.startsWith("#precommande")) {
      const e = preco();
      if (!e) return { s: null, txt: `${t("Les précommandes sont fermées.")} <a href="#commande">${t("Voir les commandes du jour →")}</a>` };
      return { s: e, txt: t("Précommande pour <strong>{n}</strong> : {j}, {p}, à {l}. Choisis ton créneau de retrait. Précommandes ouvertes jusqu'au {f}.",
        { n: esc(e.nom || LIEUX[e.lieu].nom), j: jourDate(dateIso(e.date)), p: per(e), l: esc(LIEUX[e.lieu].nom), f: finPreco(e) }) };
    }
    // Un lien par évènement (le premier jour encore ouvert) : l'encart « Où sommes-nous » propose ensuite chaque jour
    const lienPreco = precosOuvertes().sort((a, b) => a.date.localeCompare(b.date)).filter((e, i, l) => l.findIndex(x => x.nom === e.nom && x.lieu === e.lieu) === i)
      .map(e => ` <a href="#precommande-${e.date}">${t("Précommander pour {n} →", { n: esc(e.nom || LIEUX[e.lieu].nom) })}</a>`).join("");
    const s = serviceCommandable();
    if (s) return { s, txt: t("Commandes ouvertes pour le <strong>service du {p}</strong> à {l}. Premier retrait à <strong>{h}</strong>.", { p: per(s), l: esc(LIEUX[s.lieu].nom), h: hA(premierCreneau(s)) }) + lienPreco };
    const enCours = R.stopDebut && servicesDu(sim.dow).find(x => !x.sansCommande && !x.precommandeFin && sim.min >= min(x.debut) && sim.min < min(x.fin));
    if (enCours) return { s: null, txt: t("Les commandes en ligne sont fermées pour ce service : passe directement au camion, on t'attend à <strong>{l}</strong> !", { l: esc(LIEUX[enCours.lieu].nom) }) + lienPreco };
    const aVenir = servicesDu(sim.dow).find(x => !x.sansCommande && !x.precommandeFin && sim.min < min(x.debut) - OUVERTURE_AVANT);
    if (aVenir) return { s: null, txt: t("Les commandes ouvrent à <strong>{h}</strong> pour le service du {p}.", { h: hA(min(aVenir.debut) - OUVERTURE_AVANT), p: per(aVenir) }) + lienPreco };
    const ev = servicesDu(sim.dow).find(x => (x.sansCommande || x.precommandeFin) && sim.min < min(x.fin));
    if (ev) return { s: null, txt: t("Ce {p}, on est à <strong>{l}</strong> ({h}) : pas de commande en ligne, on te sert sur place.", { p: per(ev), l: esc(LIEUX[ev.lieu].nom), h: plage(ev) }) + lienPreco };
    const p = prochainService(sim.dow, 24 * 60, true);
    if (!p) return { s: null, txt: t("Pas de commande possible pour le moment. Le planning arrive très vite.") + lienPreco };
    return { s: null, txt: t("Pas de commande possible pour le moment. Prochain service <strong>{q}</strong> : commandes dès {h}.", { q: quand(p), h: hA(min(p.s.debut) - OUVERTURE_AVANT) }) + lienPreco };
  }

  function rendreCommande() {
    const { s, txt } = messageCommande();
    $("etat-commande").innerHTML = txt;
    $("commande-titre").innerHTML = location.hash.startsWith("#precommande") ? t("Précommande") + (carteActive() === "halloween" ? ` <span class="fantome" aria-hidden="true">👻</span>` : "") : t("Commander");
    const reste = stockBurgers - burgersPanier();
    $("produits").innerHTML = parGroupe(filtres(), p => {
      const off = indispo(p), q = qteProduit(p.id) + (p.id === POULET.doux ? qteProduit(POULET.hot) : 0) + (p.id === GRILLED.ids[0] ? qteProduit(GRILLED.ids[1]) + qteProduit(GRILLED.ids[2]) : 0);
      const peutAjouter = s && (!p.burger || reste > 0);
      const bas = off ? `<span class="etiquette">${off}</span>`
        : `<span class="qte"><button type="button" data-moins="${p.id}" aria-label="${t("Retirer un {n}", { n: esc(p.nom) })}" ${q ? "" : "disabled"}>−</button>
            <span aria-live="polite">${q}</span>
            <button type="button" data-plus="${p.id}" aria-label="${t("Ajouter un {n}", { n: esc(p.nom) })}" ${peutAjouter ? "" : "disabled"}>+</button></span>`;
      return `<article class="produit ${off ? "produit--off" : ""}">
        <div class="produit__visuel">${visuel(p)}${badge(p)}</div>
        <div><h3 class="produit__nom t">${esc(nomAff(p))}${feuille(p)}</h3><p class="produit__desc">${esc(p.desc)}</p>
          <div class="produit__bas"><span class="prix">${(p.menu && !p.menuBurger) || p.variantes || estGrilled(p.id) ? t("dès") + " " : ""}${euros(p.variantes ? Math.min(...p.variants.map(v => v.prix)) : p.prix)}</span>${bas}</div></div>
      </article>`;
    }, "produits");
    // Pas de compteur : le quota en ligne n'est pas le stock réel du camion.
    $("stock").innerHTML = !s ? ""
      : stockBurgers <= 0 ? `<p class="alerte">${t("Plus de burgers à commander en ligne. Passe au camion ou appelle-nous au {tel}, il en reste peut-être sur place !", { tel: telHtml })}</p>`
      : reste <= 5 ? `<p class="alerte">${t("Presque complet en ligne.")}</p>` : "";
    const n = nbArticles();
    $("barre").hidden = !n || !s || vue() !== "commande";
    $("barre-txt").textContent = `${n} ${n > 1 ? t("articles") : t("article")} · ${euros(totalPanier())}`;
  }

  function rendrePanier() {
    const s = serviceCommandable(), corps = $("panier-corps");
    if (!s) { corps.innerHTML = `<p class="avert">${t("Les commandes sont fermées pour le moment.")}</p>`; return; }
    const l = LIEUX[s.lieu], nb = burgersPanier(), premier = premierCreneau(s);
    const lignes = panier.map((l, i) => { const p = produit(l.id);
      return `<div class="ligne-panier"><span><span class="ligne-panier__nom">${l.n} × ${esc(p.nom)}</span>${l.opts.length ? `<span class="ligne-panier__opts">${esc(l.opts.map(o => t(o)).join(", "))}</span>` : ""}</span>
        <span class="ligne-panier__droite"><span class="prix">${euros(l.prix * l.n)}</span><button type="button" class="moins" data-ligne="${i}" aria-label="${t("Retirer un {n}", { n: esc(p.nom) })}">−</button></span></div>`; }).join("");
    const liste = creneaux(s).filter(c => c.debut >= premier);
    const besoin = Math.max(nb, 1); // une commande sans burger prend quand même un créneau
    const idxChoisi = liste.findIndex(c => c.debut === creneauChoisi);
    const resa = idxChoisi >= 0 ? reservation(liste, idxChoisi, besoin) : null;
    if (!resa) creneauChoisi = null;
    heureRetrait = resa ? resa[resa.length - 1].debut : null;
    // Répartition des burgers par quart d'heure, lue par le compteur de créneaux (ex. « 12h15:5|12h30:2 »).
    repartition = nb && resa ? resa.map(r => `${hh(r.debut)}:${r.n}`).join("|") : "";
    const reserves = new Map(nb && resa ? resa.map(r => [r.debut, r.n]) : []);
    const delai = s.precommandeFin ? t("Précommande : retrait le {j}, dès {h}.", { j: minus(jourDate(jourCommande())), h: hA(premier) })
      : sim.min < min(s.debut) ? t("Commande avant le service : retrait possible dès {h}.", { h: hA(premier) })
      : t("Service en cours : premier retrait à {h} (30 min de préparation).", { h: hA(premier) });
    const multi = nb && resa && resa.length > 1
      ? `<p class="avert">${t("Grosse commande : {r}. Commande complète à <strong>{h}</strong>.", { r: resa.map(r => t(r.n > 1 ? "{n} burgers à {h}" : "{n} burger à {h}", { n: r.n, h: hA(r.debut) })).join(" + "), h: hA(heureRetrait) })}</p>` : "";
    const grille = `<div class="creneaux" role="group" aria-label="${t("Créneaux de retrait")}">${liste.map((c, i) => {
        const ok = !!reservation(liste, i, besoin);
        const ajout = reserves.get(c.debut) || 0;
        const pts = Array.from({ length: MAX_PAR_CRENEAU }, (_, k) => `<i class="${k < c.pris ? "pris" : k < c.pris + ajout ? "moi" : ""}"></i>`).join("");
        return `<button type="button" class="creneau ${ajout && c.debut !== creneauChoisi ? "creneau--reserve" : ""}" data-creneau="${c.debut}" aria-pressed="${creneauChoisi === c.debut}" ${ok ? "" : "disabled"}
          aria-label="${hA(c.debut)}, ${t("{n} places", { n: MAX_PAR_CRENEAU - c.pris })}"><b>${hA(c.debut)}</b><span class="places">${pts}</span></button>`;
      }).join("")}</div>${multi}
      <p class="regle">${t("Chaque point = 1 burger (max {n} par ¼ h). Au-delà, le reste passe sur le créneau suivant.", { n: MAX_PAR_CRENEAU })} ${delai}</p>`;
    corps.innerHTML = `${lignes}
      <div class="sous-titre">${t("Retrait")}</div>
      <div class="retrait"><strong>${esc(l.nom)}</strong>${adr(l)} · ${s.precommandeFin ? jourDate(jourCommande()) + " · " : ""}${t(s.periode)} ${plage(s)}</div>
      <div class="sous-titre">${t("Créneau")}</div>${grille}
      <div class="total"><span>${t("Total")}</span><span>${euros(totalPanier())}</span></div>
      <div class="collect">
        <p class="collect__titre t">Click &amp; collect</p>
        <p>${t("Pas de livraison : tu viens chercher ta commande au camion.")}</p>
        <p><strong>${esc(l.nom)}</strong>, ${adr(l)}<br>${jourDate(jourCommande())}${heureRetrait != null ? ` · <strong>${hA(heureRetrait)}</strong>` : `, ${t("à l'heure du créneau choisi")}`}</p>
        <label class="collect__case"><input type="checkbox" id="compris" ${compris ? "checked" : ""}> ${t("J'ai compris que je viens chercher ma commande au camion.")}</label>
      </div>
      ${alcoolSeul() ? `<p class="avert">${t("La bière ne peut pas être commandée seule : ajoute un burger, des frites ou une autre boisson.")}</p>` : ""}
      <button type="button" class="btn btn--plein payer" id="payer" ${creneauChoisi == null || !compris || alcoolSeul() ? "disabled" : ""}>
        ${alcoolSeul() ? t("Ajoute un autre produit") : creneauChoisi == null ? t("Choisis un créneau") : !compris ? t("Coche la case pour payer") : t("Payer · retrait à {h}", { h: hA(heureRetrait) })}</button>`;
  }

  // ------------------------------------------------------------------
  // Pages (accueil / commande) et évènements
  // ------------------------------------------------------------------
  const vue = () => location.hash === "#commande" || location.hash.startsWith("#precommande") ? "commande" : "accueil";
  function afficherVue() {
    document.querySelectorAll("[data-vue]").forEach(el => el.hidden = el.dataset.vue !== vue());
    window.scrollTo(0, 0);
    creneauChoisi = null;
    // Ambiance de la carte d'évènement (ex. Halloween : violet + orange, citrouilles, fantôme) : voir omi.css
    document.documentElement.dataset.ambiance = vue() === "commande" ? carteActive() : "";
    if (vue() === "commande") { // passage carte habituelle ↔ carte d'évènement : on retire les articles de l'autre carte
      const avant = panier.length;
      for (let i = panier.length - 1; i >= 0; i--) if ((produit(panier[i].id)?.carte ?? "") !== carteActive()) panier.splice(i, 1);
      if (panier.length < avant) { sauver(); toast(t("Ton panier a été vidé : cette carte est différente.")); }
      if (!carte().some(p => filtre === "tout" || p.cat === filtre)) filtre = "tout";
      rendreFiltres();
    }
    rendreCommande(); chargerOccupation();
  }
  function rendreFiltres() {
    const cats = new Set(carte().map(p => p.cat));
    document.querySelectorAll("[data-filtres]").forEach(el => el.innerHTML = FILTRES.filter(([id]) => id === "tout" || cats.has(id)).map(([id, nom]) =>
      `<button type="button" class="filtre" data-filtre="${id}" aria-pressed="${filtre === id}">${nom}</button>`).join(""));
  }
  document.addEventListener("click", e => {
    const f = e.target.closest("[data-filtre]");
    if (f) { filtre = f.dataset.filtre; rendreFiltres(); rendreVitrine(); rendreCommande(); }
  });
  function tout() { rendreFiltres(); rendreOu(); rendreAvenir(); rendreSemaine(); rendreVitrine(); rendreCommande(); if ($("panier").open) rendrePanier(); }

  $("produits").addEventListener("click", e => {
    const plus = e.target.closest("[data-plus]"), moins = e.target.closest("[data-moins]");
    if (plus) { const p = produit(plus.dataset.plus); if (p.options || p.menu || p.variantes || p.id === POULET.doux || estGrilled(p.id)) return ouvrirDetail(p.id); return siMajeur(p.alcool, () => { ajouter(p.id); rendreCommande(); }); }
    if (moins) { const ids = moins.dataset.moins === POULET.doux ? [POULET.doux, POULET.hot] : estGrilled(moins.dataset.moins) ? GRILLED.ids : [moins.dataset.moins], i = panier.map(l => ids.includes(l.id)).lastIndexOf(true); if (i >= 0) retirerUn(i); }
    if (plus || moins) rendreCommande();
  });
  $("vitrine").addEventListener("click", e => { const c = e.target.closest("[data-detail]"); if (c) ouvrirDetail(c.dataset.detail); });
  $("detail-corps").addEventListener("click", e => {
    const b = e.target.closest("[data-ajouter]");
    if (!b) return;
    const p = produit(b.dataset.ajouter);
    if (p.variantes) {
      const v = varianteChoisie();
      if (v && (!p.burger || stockBurgers - burgersPanier() > 0))
        ajouter(p.id, [...choixVar.val, ...choixVar.retraits.map(c => t(c))], v.prix, v.id, choixVar.retraits.length ? { "Retraits": choixVar.retraits.join(", ") } : {});
      $("detail").close();
      return rendreCommande();
    }
    if (p.menu) return siMajeur(produit(choixMenu.boisson)?.alcool, () => {
      const v = varianteMenu();
      if (v && stockBurgers - burgersPanier() > 0) ajouter(p.id, optsMenu(), prixMenu(), v.id, propsMenu());
      $("detail").close();
      return vue() === "commande" ? rendreCommande() : (location.hash = "commande");
    });
    const opts = [...$("detail-corps").querySelectorAll("input[name=opt]:checked")].map(x => x.value).filter(v => v !== "Sans sauce");
    if (p.options && p.options.type === "sauce" && !opts.length) opts.push("Sans sauce");
    const props = !opts.length ? {} : p.options?.type === "sauce" ? { "Sauce": opts[0] } : { "Retraits": opts.join(", ") };
    siMajeur(p.alcool, () => {
      const q = p.id === POULET.doux && $("detail-corps").querySelector("input[name=hot]:checked") ? produit(POULET.hot) : choixGrilled ? produit(choixGrilled.id) : p;
      if (!q) return;
      if (!p.burger || stockBurgers - burgersPanier() > 0) ajouter(q.id, opts, q.prix, q.variants[0].id, props);
      $("detail").close();
      if (vue() === "commande") rendreCommande(); else location.hash = "commande";
    });
  });
  $("ouvrir-planning").addEventListener("click", () => $("planning").showModal());
  $("barre").addEventListener("click", () => { rendrePanier(); $("panier").showModal(); chargerOccupation(); });
  $("panier-corps").addEventListener("change", e => { if (e.target.id === "compris") { compris = e.target.checked; rendrePanier(); } });
  $("panier-corps").addEventListener("click", e => {
    const c = e.target.closest("[data-creneau]");
    if (c && !c.disabled) { creneauChoisi = +c.dataset.creneau; rendrePanier(); }
    const m = e.target.closest("[data-ligne]");
    if (m) { retirerUn(+m.dataset.ligne); rendreCommande(); if (nbArticles()) rendrePanier(); else $("panier").close(); }
    if (e.target.closest("#payer")) payer();
  });
  document.querySelectorAll("dialog").forEach(d => d.addEventListener("click", e => { if (e.target === d || e.target.closest("[data-fermer]")) d.close(); }));
  addEventListener("hashchange", afficherVue);
  // Bière : le client confirme qu'il a 18 ans avant l'ajout (une fois par visite) ; pièce d'identité demandée au retrait.
  let majeur = (() => { try { return sessionStorage.getItem("omi-majeur") === "1"; } catch { return false; } })();
  function siMajeur(alcool, suite) {
    if (!alcool || majeur) return suite();
    const d = document.createElement("dialog"); d.className = "feuille majeur";
    d.innerHTML = `<div class="feuille__corps"><p class="majeur__titre t">${t("Réservé aux 18 ans et plus")}</p>
      <p>${t("La vente d'alcool est interdite aux mineurs. Une pièce d'identité te sera demandée au retrait.")}</p>
      <div class="majeur__boutons"><button type="button" class="btn btn--plein" data-oui>${t("J'ai 18 ans ou plus")}</button>
      <button type="button" class="btn" data-non>${t("J'ai moins de 18 ans")}</button></div></div>`;
    document.body.append(d); d.showModal();
    d.addEventListener("close", () => d.remove());
    d.addEventListener("click", e => {
      if (e.target.closest("[data-oui]")) { majeur = true; try { sessionStorage.setItem("omi-majeur", "1"); } catch {} d.close(); suite(); }
      else if (e.target.closest("[data-non]") || e.target === d) { d.close(); toast(t("Pas d'alcool pour les moins de 18 ans : choisis une autre boisson.")); }
    });
  }
  const alcoolPanier = () => panier.some(l => produit(l.id)?.alcool || l.opts.includes("Bière"));
  function toast(t) { const el = $("toast"); el.textContent = t; el.hidden = false; clearTimeout(toast.t); toast.t = setTimeout(() => el.hidden = true, 3800); }

  // ------------------------------------------------------------------
  // Paiement : envoi du panier à Shopify avec le lieu et le créneau, puis checkout
  // ------------------------------------------------------------------
  async function payer() {
    const s = serviceCommandable(), l = s && LIEUX[s.lieu];
    if (!s || heureRetrait == null || alcoolSeul()) return;
    const bouton = $("payer");
    bouton.disabled = true; bouton.textContent = t("Un instant…");
    const json = (url, corps) => fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(corps) })
      .then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));
    try {
      await json("/cart/clear.js", {});
      const jour = jourCommande(), jourFr = `${JOURS[(jour.getDay() + 6) % 7]} ${jour.getDate()}/${String(jour.getMonth() + 1).padStart(2, "0")}`;
      const retrait = `${l.nom} · ${jourFr} à ${hh(heureRetrait)} · Click & collect, pas de livraison${s.precommandeFin ? " · PRÉCOMMANDE" : ""}`;
      // Shopify affiche le panier en ordre inverse d'ajout : la mention « Retrait » va sur le dernier article pour apparaître en premier au paiement.
      const dernier = panier.length - 1;
      await json("/cart/add.js", { items: panier.map((x, i) => ({ id: x.variant, quantity: x.n, properties: i === dernier ? { "Retrait": retrait, ...x.props } : x.props })) });
      await json("/cart/update.js", { attributes: {
        "Retrait": `${l.nom}, ${l.adresse}`,
        "Service": `${jourFr} — ${s.periode}${s.precommandeFin ? ` (précommande ${s.nom || ""})` : ""}`,
        "Créneau": hh(heureRetrait),
        "Itinéraire": maps(l),
        "_Répartition": repartition,
        "Date": iso(jour),
        ...(s.precommandeFin && { "Précommande": s.nom || "oui" }),
        ...(alcoolPanier() && { "Alcool": "majorité déclarée par le client (pièce d'identité à vérifier au retrait)" }), // le compteur étiquette la commande (ex. « Halloween »)
        ...(TEST && { "Mode test": `oui (${TEST.texte})` }),
      } });
      panier.length = 0; sauver();
      location.href = "/checkout";
    } catch (e) {
      bouton.disabled = false; bouton.textContent = t("Payer · retrait à {h}", { h: hA(heureRetrait) });
      toast(e?.description || t("Le paiement n'a pas pu démarrer. Réessaie dans un instant."));
    }
  }

  // Occupation des créneaux (compteur en ligne). Sans compteur : tout est libre.
  const occupation = {};
  async function chargerOccupation() {
    if (!R.creneauxUrl) return;
    try {
      const frais = await (await fetch(`${R.creneauxUrl}?date=${iso(jourCommande())}`, { cache: "no-store" })).json();
      for (const k in occupation) delete occupation[k];
      Object.assign(occupation, frais); tout();
    } catch {}
  }

  // Le site reste juste même ouvert longtemps : on recalcule l'heure chaque minute.
  setInterval(() => { horloge(); chargerOccupation(); if (!document.querySelector("dialog[open]")) tout(); }, 60000);
  chargerOccupation();

  tout();
  afficherVue();
})();
